import type { Component } from 'vue'

export interface DropdownItem {
  type?: 'item' | 'separator'
  label?: string
  icon?: Component
  action?: () => void
  danger?: boolean
  disabled?: boolean
  loading?: boolean
}

export function isActionableDropdownItem(item: DropdownItem): boolean {
  return item.type !== 'separator' && Boolean(item.label || item.action)
}

/** Drops empty rows and trims redundant separators for stable split-button / menu rendering. */
export function normalizeDropdownMenuItems(items: DropdownItem[]): DropdownItem[] {
  const result: DropdownItem[] = []

  for (const item of items) {
    if (item.type === 'separator') {
      if (result.length === 0) continue
      if (result[result.length - 1]?.type === 'separator') continue
      result.push(item)
      continue
    }
    if (!isActionableDropdownItem(item)) continue
    result.push(item)
  }

  while (result.length > 0 && result[result.length - 1]?.type === 'separator') {
    result.pop()
  }

  return result
}

export function hasActionableDropdownItems(items: DropdownItem[]): boolean {
  return normalizeDropdownMenuItems(items).some((item) => item.type !== 'separator')
}
